import LegalPageLayout from "@/components/LegalPageLayout";
import { COMPANY } from "@shared/company-info";

export default function Lgpd() {
  return (
    <LegalPageLayout
      title="Aviso LGPD"
      subtitle="Como a Lead Conversa cumpre a Lei Geral de Proteção de Dados (Lei nº 13.709/2018)."
      lastUpdated={COMPANY.lastUpdatedLegal}
    >
      <h2>Nosso compromisso</h2>
      <p>
        A <strong>Lead Conversa</strong>, produto da <strong>{COMPANY.legalEntity}</strong>{" "}
        (CNPJ {COMPANY.cnpj}), reconhece a proteção de dados pessoais como valor essencial do
        negócio. Este aviso resume, em linguagem simples, como cumprimos a LGPD. Os detalhes
        completos estão na nossa <a href="/privacidade">Política de Privacidade</a>.
      </p>

      <h2>Papéis</h2>
      <ul>
        <li>
          <strong>Controladora:</strong> em relação aos dados de nossos clientes (tenants) e
          visitantes do nosso site.
        </li>
        <li>
          <strong>Operadora:</strong> em relação aos dados de contatos que nossos clientes
          carregam na plataforma para executar suas próprias campanhas e atendimentos — nesse
          caso, seguimos as instruções e bases legais definidas pelo Controlador (nosso
          cliente).
        </li>
      </ul>

      <h2>Encarregado pelo Tratamento de Dados (DPO)</h2>
      <p>
        Para exercício de direitos, dúvidas ou reclamações:{" "}
        <a href={`mailto:${COMPANY.dpoEmail}`}>{COMPANY.dpoEmail}</a>.
      </p>

      <h2>Seus direitos como titular (art. 18 da LGPD)</h2>
      <ul>
        <li>Confirmar a existência de tratamento;</li>
        <li>Acessar seus dados;</li>
        <li>Corrigir dados incompletos, inexatos ou desatualizados;</li>
        <li>
          Anonimizar, bloquear ou eliminar dados desnecessários ou tratados em desconformidade;
        </li>
        <li>Solicitar portabilidade;</li>
        <li>Eliminar dados tratados com base em consentimento;</li>
        <li>Ser informado sobre compartilhamentos com terceiros;</li>
        <li>Revogar consentimento a qualquer momento.</li>
      </ul>

      <h2>Como exercer seus direitos</h2>
      <p>
        Envie sua solicitação para{" "}
        <a href={`mailto:${COMPANY.dpoEmail}`}>{COMPANY.dpoEmail}</a> ou pelo endereço postal{" "}
        {COMPANY.addressFormatted}. Podemos solicitar informações adicionais para confirmar sua
        identidade antes de atender o pedido. Responderemos em até 15 dias, conforme prazo legal.
      </p>

      <h2>Se você é contato de um cliente da Lead Conversa</h2>
      <p>
        Caso tenha recebido uma comunicação (e-mail ou WhatsApp) enviada através da nossa
        plataforma por uma empresa cliente, recomendamos que contate primeiro aquela empresa,
        que é a <strong>Controladora</strong> dos seus dados. Ainda assim, podemos ajudar a
        encaminhar sua solicitação.
      </p>

      <h2>Segurança</h2>
      <p>
        Adotamos medidas técnicas e organizacionais razoáveis: TLS em trânsito, controles de
        acesso, segregação de ambientes, registro de auditoria e processos de resposta a
        incidentes. Em caso de incidente de segurança relevante, notificamos a ANPD e os
        titulares afetados nos prazos legais.
      </p>

      <h2>Reclamações à ANPD</h2>
      <p>
        Se entender que seus direitos não foram adequadamente atendidos, você pode apresentar
        reclamação à <strong>Autoridade Nacional de Proteção de Dados (ANPD)</strong>.
      </p>
    </LegalPageLayout>
  );
}
